"use client"

import type React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useState, useEffect } from "react"
import "./DashboardSidebar.css"

interface MenuItem {
  id: string
  label: string
  icon: React.ReactNode
  path: string
  badge?: number
  subItems?: MenuItem[]
}

interface DashboardSidebarProps {
  collapsed: boolean
  onToggle?: () => void
}

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({ collapsed, onToggle }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set())

  const menuItems: MenuItem[] = [
    {
      id: "home",
      label: "Home",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9,22 9,12 15,12 15,22" />
        </svg>
      ),
      path: "/dashboard",
    },
    {
      id: "connectors",
      label: "Connectors",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3" />
          <path d="M12 1v6M12 17v6M4.22 4.22l4.24 4.24M15.54 15.54l4.24 4.24M1 12h6M17 12h6M4.22 19.78l4.24-4.24M15.54 8.46l4.24-4.24" />
        </svg>
      ),
      path: "/dashboard/connectors",
      // badge: 3,
    },
    // {
    //   id: "users",
    //   label: "Manage Users",
    //   icon: (
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    //       <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    //       <circle cx="8.5" cy="7" r="4" />
    //       <path d="M20 8v6M23 11l-3 3-3-3" />
    //     </svg>
    //   ),
    //   path: "/dashboard/users",
    // },
    // {
    //   id: "analytics",
    //   label: "Analytics",
    //   icon: (
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    //       <path d="M3 3v18h18" />
    //       <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
    //     </svg>
    //   ),
    //   path: "/dashboard/analytics",
    // },
    {
      id: "account",
      label: "Account",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      path: "/dashboard/account",
      subItems: [
        // {
        //   id: "profile",
        //   label: "Profile",
        //   icon: (
        //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        //       <circle cx="12" cy="12" r="3" />
        //     </svg>
        //   ),
        //   path: "/dashboard/account/profile",
        // },
        {
          id: "account-details",
          label: "Account Details",
          icon: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
            </svg>
          ),
          path: "/dashboard/profile",
        },
      ],
    },
    // {
    //   id: "settings",
    //   label: "Settings",
    //   icon: (
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    //       <circle cx="12" cy="12" r="3" />
    //       <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    //     </svg>
    //   ),
    //   path: "/dashboard/settings",
    // },
  ]

  // Auto-expand parent items based on current path
  useEffect(() => {
    const currentPath = location.pathname
    const newExpanded = new Set<string>()

    menuItems.forEach((item) => {
      if (item.subItems) {
        const hasActiveSubItem = item.subItems.some((subItem) => currentPath === subItem.path)
        if (hasActiveSubItem) {
          newExpanded.add(item.id)
        }
      }
    })

    setExpandedItems(newExpanded)
  }, [location.pathname])

  const handleMenuClick = (path: string, hasSubItems?: boolean, itemId?: string) => {
    if (hasSubItems && itemId) {
      // Toggle expansion for items with sub-items
      setExpandedItems((prev) => {
        const newExpanded = new Set(prev)
        if (newExpanded.has(itemId)) {
          newExpanded.delete(itemId)
        } else {
          newExpanded.add(itemId)
        }
        return newExpanded
      })
    } else {
      // Navigate for regular items
      navigate(path)
    }
  }

  const isActive = (path: string): boolean => {
    return location.pathname === path
  }

  const isParentActive = (item: MenuItem): boolean => {
    if (item.subItems) {
      return item.subItems.some((subItem) => isActive(subItem.path))
    }
    return isActive(item.path)
  }

  return (
    <aside className={`dashboard-sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {!collapsed && (
          <div className="sidebar-brand">
            <span className="brand-icon">⚡</span>
            <span className="brand-text">NetzSync</span>
          </div>
        )}
        {onToggle && (
          <button className="sidebar-toggle-btn" onClick={onToggle} title="Toggle Sidebar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id} className="nav-item-container">
              <button
                className={`nav-item ${isParentActive(item) ? "active" : ""} ${item.subItems ? "has-submenu" : ""}`}
                onClick={() => handleMenuClick(item.path, !!item.subItems, item.id)}
                title={collapsed ? item.label : undefined}
              >
                <span className="nav-icon">{item.icon}</span>
                {!collapsed && (
                  <>
                    <span className="nav-label">{item.label}</span>
                    {item.badge && <span className="nav-badge">{item.badge}</span>}
                    {item.subItems && (
                      <span className={`nav-arrow ${expandedItems.has(item.id) ? "expanded" : ""}`}>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9" />
                        </svg>
                      </span>
                    )}
                  </>
                )}
              </button>

              {/* Sub-menu items */}
              {item.subItems && !collapsed && (
                <ul className={`sub-nav ${expandedItems.has(item.id) ? "expanded" : ""}`}>
                  {item.subItems.map((subItem) => (
                    <li key={subItem.id}>
                      <button
                        className={`sub-nav-item ${isActive(subItem.path) ? "active" : ""}`}
                        onClick={() => handleMenuClick(subItem.path)}
                      >
                        <span className="sub-nav-icon">{subItem.icon}</span>
                        <span className="sub-nav-label">{subItem.label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        {!collapsed && (
          <div className="sidebar-footer-content">
            <div className="footer-info">
              <span className="footer-version">v2.1.0</span>
            </div>
          </div>
        )}
      </div>
    </aside>
  )
}

export default DashboardSidebar
